import React from 'react'
import { createComponent } from 'react-fela'
import { __typographyWrap } from './__style'

const Typography = ({
	children,
	variant,
	tag,
	color,
	attribute = {},
	bottomSpace,
	ellipsis,
	center,
	styles = {},
}) => {
	const TypographyComp = createComponent(
		__typographyWrap,
		tag || 'span',
		Object.keys(attribute)
	)

	return (
		<TypographyComp
			variant={variant}
			color={color}
			{...attribute}
			bottomSpace={bottomSpace}
			ellipsis={ellipsis}
			center={center}
			style={{ ...styles }}
		>
			{children}
		</TypographyComp>
	)
}

Typography.defaultProptypes = {
	children: 'Lorem ipsum',
	variant: 'title1',
	tag: '',
	color: '',
	attribute: {},
	ellipsis: false,
	center: false,
}

export default Typography
